import { Component, signal, output, input, computed, effect } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'base-search-cart-quantity-input',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './search-cart-quantity-input.component.html',
  styleUrls: ['./search-cart-quantity-input.component.scss']
})
export class SearchCartQuantityInputComponent {

  readonly value = input<number>(1);

  private _value = signal<number>(1);
  readonly currentValue = this._value.asReadonly();

  readonly canDecrease = computed(() => this._value() > 0);

  // Update outputs to use Angular 20 output() function
  increase$ = output<number>();
  decrease$ = output<number>();
  quantityChanged$ = output<number>();

  constructor() {
    effect(() => {
      const inputValue = this.value();
      this._value.set(inputValue);
    });
  }

  changeQuantity(quantity: string) {
    if (isNaN(+quantity) || +quantity === 0) {
      return;
    }
    const newValue = +quantity;
    this._value.set(newValue);
    this.quantityChanged$.emit(newValue);
  }

  onIncrease() {
    const newValue = this._value() + 1;
    this._value.set(newValue);
    this.increase$.emit(newValue);
  }

  onDecrease() {
    if (this.canDecrease()) {
      const newValue = this._value() - 1;
      this._value.set(newValue);
      this.decrease$.emit(newValue);
    }
  }
}


